module.exports = __webpack_public_path__ + "img/1F1EC-1F1F7.8d0e76ca.svg";